// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutWrapper} from 'components/Layout';
import {LocalizedParagraph, useLocalized} from 'components/Localized';
import {BackgroundImage} from 'components/Image';
import ImgClose from 'assets/images/disclaimer/btn-popup-close.svg';
import { isMobile, isMobileSafari, isChrome, isIOS } from 'react-device-detect';

type Props = {
  textKey?: string,
  popupTextKey?: string,
  onPopupOpen?: () => void,
  onPopupClose?: () => void,
}

type DisclaimerPopupButtonProps = {
  onClick?: () => void,
  visible: boolean
}

function DisclaimerPopupButton(props: DisclaimerPopupButtonProps) : React.Element<any> {
  const {visible, onClick, ...others} = props;

  return (<DisclaimerPopupButtonImpl {...others} visible={visible} source="./disclaimer/btn-ic-disclainer.png" onClick={onClick} />);
}


export default function Disclaimer(props: Props): React.Element<any> {
  const localized = useLocalized();
  const textKey = props.textKey;
  const popupTextKey = props.popupTextKey || (textKey ?? "") +"_popup";
  const [opened, setOpened] = React.useState(props.popupTextKey != null);

  return (
    <DisclaimerPage>
    {!opened && textKey != null && 
      <DisclaimerClosed source="./disclaimer/img-disclaimer-bg.png">

        <button onClick={() => {
          if (props.onPopupOpen != null) {
            props.onPopupOpen();
          }

          if (localized[popupTextKey] !== undefined) {
            setOpened(!opened);
          }
          
        }} >
        <LocalizedParagraph {...localized[props.textKey]} />
        </button>
      </DisclaimerClosed>
    }
    {opened && popupTextKey != null &&
      <DisclaimerOpened source="./disclaimer/img-disclaimer-bg.png">
        <LocalizedParagraph {...localized[popupTextKey]} />
        <button onClick={() => {
            setOpened(false);
            if (props.onPopupClose != null) {
              props.onPopupClose();
            }
          }} >
          <img src={ImgClose} alt=""  />
        </button>
      </DisclaimerOpened>
    }
    </DisclaimerPage>
  );
}

const ButtonCommon = styled(BackgroundImage)`
  position: absolute;
  pointer-events: auto;

  div {
    width: 100%;
    height: 100%;

    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
`;

const DisclaimerPage = styled(LayoutWrapper)`

`;

const DisclaimerOpened = styled.div`
  
  background-color: rgba(0,0,0,0.7);
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: auto;
  height: max-content;
  pointer-events: auto;
  > button {
    position: absolute;
    right: calc(env(safe-area-inset-right) + ${props => isMobile && isChrome && isIOS ? 20 : 0}px + ${props => props.theme.layout.mobile ? 22 : 108}px);
    top: ${props => props.theme.layout.mobile ? 22 : 28}px;
    width: ${props => props.theme.layout.mobile ? 17 : 24}px;
    height: ${props => props.theme.layout.mobile ? 17 : 24}px;

    > img {
      position: absolute;
      left: 0px;
      top: 0px;
      width: ${props => props.theme.layout.mobile ? 17 : 24}px;
      height: ${props => props.theme.layout.mobile ? 17 : 24}px;
    }

  }
  > p {
    margin-left: calc(env(safe-area-inset-left) + ${props => isMobile && isChrome && isIOS ? 20 : 0}px + ${props => props.theme.layout.mobile ? 30 : 81}px);
    margin-right: calc(env(safe-area-inset-right) + ${props => isMobile && isChrome && isIOS ? 20 : 0}px + ${props => props.theme.layout.mobile ? 54 : 86}px);
    margin-bottom: ${props => props.theme.layout.mobile ? 30 : 42}px;
    margin-top: ${props => props.theme.layout.mobile ? 60 : 81}px;

  }
`;
const DisclaimerClosed = styled(BackgroundImage)`
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: auto;
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;

  button {
    > p {
     margin-right: 3px;
     margin-bottom: ${props => isMobileSafari ? "env(safe-area-inset-bottom)" : "0px"} ;
     text-align: left;
     margin-left: calc(env(safe-area-inset-left) + ${props => isMobile && isChrome && isIOS ? 20 : 0}px + ${props => props.theme.layout.mobile ? 20 : 20}px);
     margin-right: calc(env(safe-area-inset-left) + ${props => isMobile && isChrome && isIOS ? 20 : 0}px + ${props => props.theme.layout.mobile ? 20 : 20}px);

    }
    > div {
     margin-bottom: ${props => isMobileSafari ? "env(safe-area-inset-bottom)" : "0px"} ;
    }
  }
 
`;


const DisclaimerPopupButtonImpl = styled(ButtonCommon)`
  position: relative;

  width: ${props => props.theme.layout.mobile ? 12 : 19}px;
  height: ${props => props.theme.layout.mobile ? 12 : 19}px;
  visibility: ${props => props.visible ? "":"hidden"};
  
`;

export {Disclaimer, DisclaimerPopupButton};
